// Section Shopify Shopify.theme editor events

$(document)
.on('shopify:section:reorder', function(e){


});

$(document)
.on('shopify:section:load', function(e){


});


$(document)
.on('shopify:section:unload', function(e){


});

$(document)
.on('shopify:section:select', function(e){

});

$(document)
.on('shopify:section:deselect', function(e){


});

// Block Shopify Shopify.theme editor events

$(document)
.on('shopify:block:select', function(e){

});

$(document)
.on('shopify:block:deselect', function(e){

});

$(document)
.on('shopify:block:load', function(e){



});

// Document ready
$(function() {

  // Currency converter
  if (Currency.show_multiple_currencies) {
    Shopify.theme.currencyConverter.init();
  }
  
  Shopify.theme.predictiveSearch.init();

  //Select event for native multi currency checkout
  $('.shopify-currency-form select').on('change', function () {
    $(this)
      .parents('form')
      .submit();
  });



});
